import { useState, useEffect, useId } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { FaRegCheckCircle, FaCheck } from "react-icons/fa";

export default function Form() {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();
    const ubdCheckboxId = useId();
    const vpoCheckboxId = useId();

    // Функція для отримання значення з cookie
    const getCookie = (cookieName) => {
        const name = `${cookieName}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArr = decodedCookie.split(';');
        for (let i = 0; i < cookieArr.length; i++) {
            let cookie = cookieArr[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    };

    const currentPath = window.location.pathname;
    const isEn = currentPath.startsWith("/en");

    const [preloader, preloaderFormStyle] = useState("hidden");
    const [promoAlert, setPromoAlertData] = useState("");
    const [promoAlertStyle, setPromoAlerStyle] = useState("");

    const [event, setEvent] = useState({});

    const errorStyle =
        "absolute -top-2 right-0 text-red-800 z-10 bg-white text-[13px] px-[4px] leading-none rounded-r flex items-center";
    const successStyle =
        "absolute top-0 right-0 text-[#003366] z-10 text-sm h-full p-[4px] leading-none rounded-full flex items-center";

    const domain = window.location.protocol + "//" + window.location.host;

    const inputStyle = "font-medium text-base leading-none text-current appearance-none border-[1px] border-x-0 border-t-0 border-b-current w-full pb-2 placeholder:text-current placeholder:opacity-70 bg-transparent"

    const clearDataPromo = async (data) => {
        var promocodeData = {
            promocode: data,
            site_name: domain,
            action: "checkpromo",
        };

        try {
            const response = await axios.post(
                "https://ekonomika.ua/wp-content/plugins/ekonomika-requests/ekonomika-requests.php",
                promocodeData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status === 201 || response.status === 200) {
                if (response.data.check === false) {
                    setPromoAlertData(response.data.message);
                    setPromoAlerStyle(errorStyle);
                } else {
                    setPromoAlertData(<FaCheck />);
                    setPromoAlerStyle(successStyle);
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const onSubmit = async (data) => {
        try {
            preloaderFormStyle("flex");

            // Надіслати подію в GTM
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'form_send',
                formType: 'Contact',
            });

            const response = await axios.post(
                "https://ekonomika.ua/wp-content/plugins/ekonomika-requests/ekonomika-requests.php",
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.data.check !== false) {
                window.location.href = response.data;
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            preloaderFormStyle("hidden");
        }
    };

    const normalizeTel = (value) => {
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{3})(\d)/g, "($1) $2");
        if (value.length < 14) {
            value = value.replace(/(\d{3})(\d{2})(\d{2})$/, "$1-$2-$3");
        } else {
            value = value.replace(/(\d{3})(\d{2})(\d{2})(\d{2})$/, "$1-$2-$3-$4");
        }
        return value;
    };

    // URL params
    const windowUrl = window.location.search;
    const searchParams = new URLSearchParams(windowUrl);

    const utm_source = searchParams.get("utm_source") || "";
    const utm_medium = searchParams.get("utm_medium") || "";
    const utm_campaign = searchParams.get("utm_campaign") || "";
    const utm_content = searchParams.get("utm_content") || "";

    // Translated texts
    const priceNote = isEn ? "* Price before tax" : "* Ціна до оподаткування";
    const emailError = isEn ? "enter email" : "вкажіть email";
    const phoneError = isEn ? "enter phone" : "вкажіть телефон";
    const submitText = isEn ? "Submit" : "Надіслати";
    const waitText = isEn ? "Please wait..." : "Зачекайте...";
    const price = isEn ? "uah" : "грн";

    useEffect(() => {
        setValue("user_agent", navigator.userAgent);

        // Зчитування cookie _fbc та _fbp
        const fbc = getCookie("_fbc");
        const fbp = getCookie("_fbp");
        if (fbc) setValue("fbc", fbc);
        if (fbp) setValue("fbp", fbp);

        // Отримання IP-адреси за допомогою зовнішнього API
        const fetchIpAddress = async () => {
            try {
                const response = await axios.get("https://api.ipify.org?format=json"); // Використовуємо ipify API
                setValue("user_ip", response.data.ip);
            } catch (error) {
                console.error("Не вдалося отримати IP-адресу: ", error);
                setValue("user_ip", "");
            }
        };

        fetchIpAddress();
    }, [setValue]);

    return (
        <div className="flex-1">
            <form onSubmit={handleSubmit(onSubmit)} className="relative md:flex md:flex-wrap md:items-center md:gap-6  z-10">
                <div className="relative w-full mb-[10px] md:mb-0 md:flex-[calc(50%_-_12px)]">
                    <input
                        type="text"
                        {...register("name", { required: true })}
                        placeholder="Прізвище та ім’я"
                        className={inputStyle}
                    />
                    {errors.name && <div className={errorStyle}>вкажіть ім’я</div>}
                </div>

                
                <div className="relative w-full mb-[10px] md:mb-0 md:flex-[calc(50%_-_12px)]">
                    <input
                        type="email"
                        name="email"
                        {...register("email", {required: true})}
                        placeholder={isEn ? "Email" : "Пошта"}
                        className={inputStyle}
                    />
                    {errors.email && <div className={errorStyle}>{emailError}</div>}
                </div>

                <div className="w-full relative mb-[10px] md:mb-0 md:flex-[calc(50%_-_12px)]">
                    <input
                        type="text"
                        {...register("phone", {
                            required: true,
                            pattern:
                                /^\([0-9]{3}\) [0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}/,
                        })}
                        maxLength="17"
                        placeholder={isEn ? "Phone (099) 999-99-99" : "Тел. (099) 999-99-99"}
                        onChange={(event) => {
                            const {value} = event.target;
                            event.target.value = normalizeTel(value);
                        }}
                        name="phone"
                        className={inputStyle + " " + (errors.phone ? "form-control text-amber-700" : "form-control")}
                    />
                    {errors.phone && (
                        <div className={errorStyle}>{phoneError}</div>
                    )}
                </div>
                <button type="submit" name="submit" className="relative submit-form 
                    font-extrabold  uppercase inline-flex items-center justify-between gap-3 cursor-pointer
                    bg-[#ece66a] py-2 pl-3 pr-4 w-full hover:bg-[#F5D858] transition-colors duration-300 md:mb-0 md:flex-[calc(50%_-_12px)]">
                    Надіслати
                </button>

                {/*<div className="relative rounded h-max mb-6">
                    <input
                        type="text"
                        {...register("promocode")}
                        name="promocode"
                        placeholder={isEn ? "Promo code" : "Промокод"}
                        onBlur={(event) => {
                            const {value} = event.target;
                            clearDataPromo(value);
                        }}
                        className={inputStyle}
                    />
                    {promoAlert ? <div className={promoAlertStyle}>{promoAlert}</div> : null}
                </div>*/}


                <div className="flex items-center gap-3 hidden md:flex  md:mb-0">
                    <input
                        type="checkbox"
                        id={ubdCheckboxId}
                        {...register("ubd")}
                        className="mt-1 w-4 h-4 accent-white cursor-pointer"
                        value="ubd"
                    />
                    <label htmlFor={ubdCheckboxId} className="text-[14px] font-medium cursor-pointer select-none">Маю посвідчення УБД <span className="text-red-600">*</span></label>
                </div>

                <div className="flex items-center gap-3 hidden md:flex  md:mb-0">
                    <input type="checkbox"  id={vpoCheckboxId}
                        {...register("vpo")}
                        className="text-[14px] font-medium cursor-pointer select-none"
                        value="vpo"
                    />
                    <label htmlFor={vpoCheckboxId} className="text-[14px] font-medium cursor-pointer select-none underline">Маю посвідчення ВПО <span className="text-red-600">*</span></label>
                </div>
                

                

                <input name="site_name" {...register("site_name")} type="hidden" value={domain}/>
                <input name="price" {...register("price")} type="hidden" value="5000"/>
                <input name="local" {...register("local")} type="hidden" value={isEn}/>
                <input name="utm_source" {...register("utm_source")} type="hidden" value={utm_source}/>
                <input name="utm_medium" {...register("utm_medium")} type="hidden" value={utm_medium}/>
                <input name="utm_campaign" {...register("utm_campaign")} type="hidden" value={utm_campaign}/>
                <input name="utm_content" {...register("utm_content")} type="hidden" value={utm_content}/>
                <input name="user_agent" {...register("user_agent")} type="hidden"/>
                <input name="user_ip" {...register("user_ip")} type="hidden"/>
                <input name="fbc" type="hidden" {...register("fbc")} />
                <input name="fbp" type="hidden" {...register("fbp")} />

                <div>
                    <a href="https://forms.gle/GaZCkjFzgTFZrdKx9"
                    target="_blank"
                    className="text-sm text-gray-400 hover:text-gray-700 w-full font-normal inline-flex items-center cursor-pointer">Корпоративним клієнтам</a>
                </div>

                <div
                    className={"absolute top-0 left-0 w-full h-full d-flex items-center justify-center bg-white/90 text-[#000] " + preloader}>
                    <div className="flex text-2xl justify-center items-center">
                        <FaRegCheckCircle className="mr-3"/>
                        <span>{waitText}</span>
                    </div>
                </div>
            </form>
            <p className="text-xs text-gray-400  mt-3 max-w-[540px]">*Участь для УБД та ВПО безкоштовна (за умови наявності посвідчення) </p>

        </div>
    );
}
